import About from "components/About";
import AboutSection from "components/AboutSection";
import AboutSection2 from "components/AboutSection2";
import Gallery from "components/common/Gallery";
import Footer from "components/Footer";
import Header from "components/header";
import PathShow from "components/PathShow";
import WhySection from "components/WhySection";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const TermsPage = () => {
  const [t] = useTranslation("global");

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"EMPORIUM POINT | Terms and Conditions"}</title>
        <meta
          name="og:title"
          content={"EMPORIUM POINT | Terms and Conditions"}
        />
      </Helmet>
      <div className="font-[Yekan] mt-[99px] md:mt-[83px]">
        <Header />
        <div className="max-w-4xl mx-auto p-6">
          <h1 className="text-3xl font-bold mb-6">{t("terms.title")}</h1>
          <p className="mb-4">{t("terms.intro")}</p>
          <p className="mb-4">{t("terms.newtext")}</p>
          <h2 className="text-xl font-semibold mb-2">
            {t("terms.acceptanceTitle")}
          </h2>
          <p className="mb-4">{t("terms.acceptanceText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.productsTitle")}
          </h2>
          <p className="mb-4">{t("terms.productsText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.returnTitle")}
          </h2>
          <p className="mb-4">{t("terms.returnText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.refundTitle")}
          </h2>
          <p className="mb-4">{t("terms.refundText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.nonReturnableTitle")}
          </h2>
          <p className="mb-4">{t("terms.nonReturnableText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.cancellationTitle")}
          </h2>
          <p className="mb-4">{t("terms.cancellationText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.damageTitle")}
          </h2>
          <p className="mb-4">{t("terms.damageText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.liabilityTitle")}
          </h2>
          <p className="mb-4">{t("terms.liabilityText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.contactTitle")}
          </h2>
          <p className="mb-4">
            {t("terms.contactText")}{" "}
            <strong>504B Rolex Tower, Deira, Dubai, UAE</strong>
          </p>
          <h2 className="text-xl font-semibold mb-2">
            {t("terms.shippingTitle")}
          </h2>
          <p className="mb-4 whitespace-pre-line">{t("terms.shippingText")}</p>

          <h2 className="text-xl font-semibold mb-2">
            {t("terms.deliveryTitle")}
          </h2>
          <p className="mb-4 whitespace-pre-line">{t("terms.deliveryText")}</p>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsPage;
